module.exports = __webpack_public_path__ + "static/media/arrow_down_blue.c9dcd63c.svg";